import React from 'react';
import { Datagrid, DateField, List, TextField } from 'react-admin';
import { Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';

const OpportunityProfileList: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/opportunities">
          Opportunities
        </MuiLink>
        <Typography color="text.primary">Profiles</Typography>
      </Breadcrumbs>
      <List>
        <Datagrid rowClick="edit" bulkActionButtons={false}>
          <TextField source="opportunityId" label="Opportunity Id" />
          <TextField source="legalEntityName" label="Legal Entity" />
          <DateField source="updatedAt" />
        </Datagrid>
      </List>
    </Container>
  );
};

export default OpportunityProfileList;
